module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'success',
    selected: 'Selected',
    chooseGiftFirst: 'Please choose a gift card first — Apple or Starbucks.',
    综合评价: "Overall Evaluation",
    inputNotSame: "Input Not Same",
    example: 'Example',
    "btnPrev": "Previous",
    // 选择语言
    popupTitle: 'Select Language',
    // 发送
    send: 'Confirm',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 发送邮件
    sendEmail: 'Send Email',
    // 改变语言
    changeLanSes: 'Language switch successful',
    // 系统标题
    title: 'Voice of Buyer',
    // 系统解释
    details: 'Listening to the voice of buyers, providing quality products and services,\nThank you for being with us!',
    fileSizeOver: "File is too large, only images within 10MB are supported.",
    lowTextarea: 'Your feedback will assist us in continually enhancing our products and services.',
    placeholderOrderNo: "Please enter the order number (format: 000-0000000-0000000)",
    "picUploadSuccessText": "Image uploaded successfully",
    "picUploadErrorText": "Image upload failed",
    "orderNotExistText": "The order does not exist",
    "orderInvalidText": "This order is invalid",
    "networkErrorText": "Network error",
    "orderErrorText": "Order error",
    // step1
    formBasic: {
        confirm_btn:"OK",
        "order_help_title": "Order Number Help",
        "order_help_content": "If you do not know your order number, Please contact us to find out how to obtain your order number. Our Email: ",
        form_code: 'Verification Code',
        form_code_placeholder: 'Please enter the verification code',
        "get_code": "Get Code",
  "code_sent_success": "Code sent successfully",
        title: 'Register Your Warranty &<br><span style="color:#C9A127">Claim Your Mystery Gift</span>',
        form_name: 'Name',
        platform_name: 'Platform',
        platform_name_placeholder: 'Please select a platform',
        form_email: 'Email',
        form_email_note: 'Enter your email for gift delivery & support.',
        form_order: 'Order Number',
        form_order_error_placeholder: 'Please enter the order number (format: 000-0000000-0000000)',
        order_why: '*How to find your Order Number?',
        order_answer: '*We don’t share your personal info with anyone. Your personal information is secure and used solely for your warranty activation.',
        btn_text: 'Activate Now',
        "form_name_placeholder": "Please enter your name",
        "form_platform_placeholder": "Please select a platform",
        "form_email_placeholder": "Please enter your email",
        "form_email_error_placeholder": "Please enter a valid email",
        "form_order_placeholder": "Please enter your order number"
    },
    // step2
    showGiftCard: {
        title: `Your extended warranty is activated.<br>
We've added <span style="font-weight:600; color:#000">9 months</span> of coverage to your product.<br>
Thank you for your purchase!`,
        text: '🎁 Claim Your $20 Gift Card & Share Your experience<br><small>(Takes less than 1 minute)</small>',
        gift_card_text: 'Choose your $20 e-Gift Card',
        btn_text: 'Get My Reward'
    },
    // step3
    expectations: {
        title: `Thank you for choosing our products and services!`,
        text: ' If it just meets your expectations or brings you a little surprise, why not take a few seconds to leave your positive reviews on the site you bought? Leave a positive review and receive a $10 gift card reward!!',
        btn_text: 'Next Step'
    },
    // step3
    star: {
        title: 'Are you satisfied with this product or our service?',
        text: ' Please give a star rating for the product below:',
        star__placeholder: 'Please rate alquestions beforesubmitting!',
        written: 'Add a written review: <span style="color:#F40000">（Optional）</span>',
        written_placeholder: 'What did you like? What did use this product for?',
        btn_text: 'Next Step'
    },
    // step4
    ensureEmail: {
        title: `Congratulation!</br>
You've finished the survey.
`,
        text: `Please double confirm the email address, you will receive gift code via this email address:</br>
 <span style="color:#F40000">customerservice8@yeah.net</span>`,
        email_placeholder: 'Please double confirm the email address!',
        btn_text: 'Next Step'
    },
    // step5
    reviewGuide: {
        title: 'How to leave a review on your purchase platform',
        subtitle: 'Select your platform to see the steps.'
    },
    channelSelect: {
        title: `Your feedback matters! `,
        text: `Thank you for leaving your valuable feedback! Now you can choose the gift you want!!!`,
        footer: '*About The Gift:</br> No Shipping Charges, No Hidden Fees, No Credit Card Required',
        btn_text: 'I Want It'
    },
    // step6
    uploadPic: {
        guideText: 'Need help taking the screenshot?<br><small>Select your purchase platform below for a quick guide.</small>',
        title: 'Please upload a screenshot of your product experience.',
        text: 'To claim your $20 Gift Card, simply submit a screenshot<br>of your published review below.',
        add_pic: 'Click to upload or drag & drop',
        add_pic_text: 'JPG / PNG, up to 10MB',
        btn_text: 'Submit & Claim Gift',
        uploading: 'Uploading... Please wait',
        upload_required: 'Please upload a screenshot before continuing.',
        "no_file_selected": "No file selected"
    },
    // step7
    cityForm: {
        title: '*Accessory</br>Shiping Address: ',
        text: '(Plz confirm your shipping address, the free gift will be arranged in 3-5 working days.)',
        form_city: 'City',
        form_state: 'State/Region',
        form_postal_code: 'Postal Code',
        form_country: 'Country',
        btn_text: 'Confirm',
        "form_city_placeholder": "Please enter your city",
        "form_state_placeholder": "Please enter your area",
        "form_postal_code_placeholder": "Please enter your postal code",
        "form_country_placeholder": "Please enter your country"
    },
    // step7
    paypalForm: {
        title: 'Where should we send your $20 Gift Card?',
        text: '(Please ensure your PayPal details are correct to avoid delays.)',
        form_paypal: 'PayPal Account',
        form_ensure_paypal: 'Confirm PayPal Account',
        form_paypal_name: 'PayPal Account Name',
        btn_text: 'Confirm',
        "form_paypal_placeholder": "Please enter your PayPal account",
        "form_ensure_paypal_placeholder": "Please confirm your PayPal account",
        "form_paypal_name_placeholder": "Please enter your PayPal name"
    },
    // thanks-all
    thanksAll: {
        doneTitle: 'All Done! 🎉',
        doneDescription: 'Your screenshot has been received! Your gift card request is now being processed.',
        request: 'Gift Card Request', processing: 'Processing', deliveryPrefix: 'Estimated delivery:', deliveryTime: '1-2 business days', deliverySuffix: 'via email.',
        rewardTitle: 'Your reward', rewardDescription: 'A $20 e-gift card will be sent to your email',
        verifyStep: 'We will verify your screenshot within 1-2 business days.', approvedStep: 'Once approved, your gift card will be sent to your email.', spamStep: "Don't forget to check your spam/junk folder.", supportText: 'Questions? Contact our support team at',
        title: 'Grateful for Your Contribution!',
        // title_desc1: 'Thank you for participating in our product survey!',
        // title_desc2: 'projector survey!',
        text: `Your valuable opinions will help us to improve product quality. 
If you have any questions during use, please feel free to contact us.`
    },
    // thanks
    thanks: {
        title: 'Congratulation!',
        title_desc1: `Your warranty is activated!
Thank you very much for your time.`,
        title_default_paypal_desc1: `Your warranty is activated!
Thank you very much for your time. Your reward will be issued within 24 to 72 hours.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
